import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  ViewChild,
} from "@angular/core";

import { SyncScrollService } from "../sync-scroll/sync-scroll.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-external-scrollbar",
  standalone: false, // NOSONAR - will be make this true in R2.
  // imports: [CommonModule, SharedModule],
  templateUrl: "./external-scrollbar.component.html",
  styleUrl: "./external-scrollbar.component.scss",
})
export class ExternalScrollbarComponent implements OnDestroy {
  @ViewChild("scrollbar", { static: false })
  private readonly scrollbar!: ElementRef;
  @Input() public targetSyncScroll!: string;
  @Input() public targetBaseWidth!: HTMLElement;

  private readonly syncScrollIndex: number = -1;
  protected scrollWidth: number = 0;

  protected get canScroll(): boolean {
    this.scrollWidth = this.targetBaseWidth.scrollWidth;
    return this.targetBaseWidth.scrollWidth > this.targetBaseWidth.clientWidth;
  }

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly syncScrollService: SyncScrollService,
  ) {}

  //For Future Reference
  // ngAfterViewInit() {
  //   this.syncScrollIndex = this.syncScrollService.add(
  //     this.targetSyncScroll,
  //     this.scrollbar,
  //   );

  //   this.onResize();
  //   this.changeDetectorRef.detectChanges();
  // }

  @HostListener("window:resize") protected onResize() {
    this.scrollWidth = this.targetBaseWidth.scrollWidth;
  }

  protected syncScroll() {
    this.syncScrollService.sync(this.targetSyncScroll, this.syncScrollIndex);
  }

  ngOnDestroy() {
    this.syncScrollService.remove(this.targetSyncScroll, this.syncScrollIndex);
  }
}
